import { NgModule } from '@angular/core';
import { DependenciesModule } from '../dependencies.module';
import { LandingRoutingModule } from './landing-routing.module';

import { LoginAdminComponent } from './login-admin/login-admin.component';
import { ConsentOtpDialogComponent, LoanrenewalYesNoComponent } from './loanrenewal-yes-no/loanrenewal-yes-no.component';
import { LandingComponent } from './landing.component';
import { ConsentDisabledComponent, ConsentFormWebComponent } from './loanrenewal-yes-no/consent-formweb.component';
import { OpenDialogYesOrNo } from './dialog-yes-or-no/dialog-yes-or-no.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LoginOtpDialogComponent } from './login-otp-dialog/login-otp-dialog.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
  

@NgModule({
  imports: [
    DependenciesModule,
    LandingRoutingModule,
    MatLegacySelectModule,
    MatLegacyProgressBarModule,
    MatLegacyTabsModule,
    MatIconModule,
    MatLegacyCardModule,
    MatToolbarModule,
    MatLegacyInputModule
  ],
  declarations: [
    LoginAdminComponent,
    LoanrenewalYesNoComponent,
    LandingComponent,
    ConsentFormWebComponent,
    ConsentDisabledComponent,
    ConsentOtpDialogComponent,
    OpenDialogYesOrNo,
    ResetpasswordComponent,
    LoginOtpDialogComponent,
    LoadingSpinnerComponent
  ]
})
export class LandingModule { }
